import { render } from "./IconPrint.vue?vue&type=template&id=3562435c"
import script from "./IconPrint.vue?vue&type=script&lang=js"
export * from "./IconPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__